export const formatRupees = (value) => {
    if (value === null || value === undefined || value === "") return "₹0";

    const num = Number(value);
    if (isNaN(num)) return value;

    return `₹${num.toLocaleString("en-IN")}`;
};